import { SVGProps } from "react";

export function Track(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      {...props}
    >
      <path
        d="M4.5 15L15.5 4M20.5 9L9.5 20M5.5 12L12.5 19M9 8.5L16 15.5M12.5 5L19.5 12"
        stroke="#063982"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
